
export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Car Accidents',
      description: 'Comprehensive representation for all types of motor vehicle accidents, from fender benders to catastrophic collisions.',
      features: ['Rear-end collisions', 'Head-on crashes', 'Intersection accidents', 'Hit and run cases']
    },
    {
      icon: 'ri-hospital-line',
      title: 'Medical Malpractice',
      description: 'Holding healthcare providers accountable when medical negligence causes harm to patients and families.',
      features: ['Surgical errors', 'Misdiagnosis', 'Birth injuries', 'Medication mistakes']
    },
    {
      icon: 'ri-footprint-line',
      title: 'Slip & Fall',
      description: 'Premises liability cases where property owners failed to maintain safe conditions for visitors.',
      features: ['Wet floors', 'Uneven surfaces', 'Poor lighting', 'Inadequate security']
    },
    {
      icon: 'ri-truck-line',
      title: 'Trucking Accidents',
      description: 'Specialized representation for serious truck accident cases involving commercial vehicles and complex regulations.',
      features: ['18-wheeler collisions', 'Driver fatigue cases', 'Cargo loading errors', 'Maintenance failures']
    },
    {
      icon: 'ri-motorbike-line',
      title: 'Motorcycle Accidents',
      description: 'Specialized representation for motorcyclists facing unique challenges and severe injuries.',
      features: ['Lane splitting incidents', 'Road hazards', 'Visibility issues', 'Protective gear failures']
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Product Liability',
      description: 'Cases involving defective products that cause injury due to design flaws or manufacturing defects.',
      features: ['Defective vehicles', 'Dangerous drugs', 'Faulty appliances', 'Unsafe toys']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-blue-900 mb-6">
            Our Practice Areas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We handle a wide range of personal injury cases across Florida and New Jersey, 
            fighting tirelessly to get you the compensation you deserve.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100">
              <div className="w-16 h-16 bg-blue-900 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-blue-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-cyan-500 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Don't See Your Case Type?</h3>
            <p className="text-blue-200 mb-6 max-w-2xl mx-auto">
              We handle many other types of personal injury cases. Contact us for a free consultation 
              to discuss your specific situation.
            </p>
            <button className="bg-cyan-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-cyan-600 transition-colors cursor-pointer whitespace-nowrap">
              Discuss Your Case
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}